import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import UnCodeForm from "../unCodeForm/unCodeForm";

export default class AddUnCode extends React.Component {
    render() {
        return (
            <AddItem
                class="add-uncode"
                header={i18n.t("dictionaries.unCodes.actions.addUnCode.header")}
                content={<UnCodeForm isUpdate={false} />}
            />
        );
    }
}